<template>
  <q-dialog v-model="setFmhTokenDialog.show"
            @keydown.escape="close()"
            persistent
            transition-show="scale"
            transition-hide="scale">
    <q-card>
      <q-form @submit.prevent.stop="save" @validation-error="onValidationError" :disabled="isLoading">
        <q-card-section>
          <div class="text-h6">Fleet Market Hub Token ({{ setFmhTokenDialog.company?.name }})</div>
        </q-card-section>

        <q-separator/>

        <q-card-section style="position:relative; width:560px; max-height: 50vh" class="scroll">
          <loading v-if="isLoading"></loading>
          <q-form>
            <div v-if="!isLoading && !isSetData" class="q-pa-sm" style="color: #ff3300;">FMH Token not yet set
            </div>
            <div class="row">
              <div class="col-12 q-pa-sm">
                <q-input v-model="fmhTokenData.token"
                         label="Token"
                         autofocus
                         :error="errors.token !== null"
                         :error-message="errors.token"
                         :rules="[val => !!val || 'Field is required']"/>
              </div>
            </div>
          </q-form>
        </q-card-section>

        <q-separator/>

        <q-card-actions>
          <div class="row" style="width: 100%">
            <div class="col-4">
              <div class="loading" v-if="isLoading">
                <q-spinner-facebook size="45px" color="primary"/>
              </div>
              <q-btn label="DELETE" color="red q-ml-sm" v-if="isSetData" @click.native="onDelete"/>
            </div>
            <div class="col-8 text-right q-pt-xs">
              <q-btn label="CLOSE" color="secondary" v-close-popup class="q-mr-sm" :disable="isLoading"/>
              <q-btn type="submit" label="SAVE" color="primary" :disable="isLoading"/>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
    <q-dialog v-model="isDeleteConfirm" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <span class="q-ml-sm">Are you sure delete FMH Token?</span>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn label="Yes" color="red" @click="handleDelete"/>
          <q-btn label="No" color="primary" v-close-popup/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-dialog>
</template>

<script>
import axios from "@/axios";
import Loading from "@/components/Loading.vue";

export default {
  name: "FmhTokenDialog",
  components: {Loading},
  data() {
    return {
      isLoading: false,
      isSetData: false,
      fmhTokenData: {
        username: '',
        password: '',
        company_code: '',
        business_unit: '',
      },
      errors: {
        username: null,
        password: null,
        company_code: null,
        business_unit: null,
      },
      isPwd: true,
      isDeleteConfirm: false,
    }
  },
  computed: {
    setFmhTokenDialog: {
      get() {
        return this.$store.state.company.setFmhTokenDialog
      },
      set(val) {
        this.$store.commit('company/SET_FMH_TOKEN_DIALOG', val)
      }
    }
  },
  methods: {
    async getCompanyFmhToken(companyId) {
      this.isLoading = true;
      // Initialize with empty token instead of null to prevent null reference
      this.clearData();
      try {
        const response = await axios.get(`/company-fmh-token/${companyId}`);
        const data = response.data.data;
        this.fmhTokenData = {
          token: data.token
        };
        this.isSetData = true;
      } catch (e) {
        this.clearData();
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    clearData() {
      this.fmhTokenData = {
        token: ''
      };
      this.isSetData = false;
    },
    clearErrors() {
      this.errors = {
        token: null
      };
    },
    onDelete() {
      this.isDeleteConfirm = true;
    },
    async handleDelete() {
      try {
        const response = await axios.delete(`/company-fmh-token/${this.setFmhTokenDialog.company.id}`);
        if (response.status === 200) {
          this.clearData();
        }
        this.$q.notify({
          message: response.data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        });
      } catch (e) {
        this.$q.notify({
          message: 'Something went wrong. Please try again.',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        });
      } finally {
        this.isDeleteConfirm = false;
      }
    },
    onValidationError(ref) {
      ref.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      })
    },
    async save() {
      this.isLoading = true
      this.clearErrors()
      try {
        console.log('d', this.fmhTokenData)
        await axios.put(
          `/company-fmh-token/${this.setFmhTokenDialog.company.id}`,
          this.fmhTokenData
        )
        this.isSetData = true
        this.$q.notify({
          message: 'FMH Token successfully set',
          color: 'green',
          timeout: 250,
          position: 'top-right',
          progress: true
        })
      } catch (err) {
        if (err.response.status === 422) {
          this.$q.notify({
            message: err.response.data.message,
            color: 'red',
            timeout: 250,
            position: 'top-right',
            progress: true
          })
          const errors = err.response.data.errors
          Object.keys(errors).map(key => {
            this.errors[key] = errors[key][0]
          })
        } else {
          this.$q.notify({
            message: 'Something went wrong',
            color: 'red',
            timeout: 250,
            position: 'top-right',
            progress: true
          })
        }
      } finally {
        this.isLoading = false
      }
    },
    close() {
      this.loading = false
      this.$store.commit('company/SET_FMH_TOKEN_DIALOG', {
        show: false,
        company: null
      })
    }
  },
  watch: {
    setFmhTokenDialog: {
      deep: true,
      async handler(val) {
        if (val.show) {
          await this.getCompanyFmhToken(val.company.id);
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.odd {
  background-color: #f5f5f5;
}
</style>
